import { Swiper } from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

document.addEventListener("DOMContentLoaded", () => {
  const heroSwiper: any = document.querySelector(".hero-swiper");
  if (!heroSwiper) return;

  new Swiper(heroSwiper, {
    modules: [Autoplay, EffectFade],
    effect: "fade",
    loop: true,
    allowTouchMove: false,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    navigation: false,
    pagination: false,
  });
});

export {};
